import React, { Component, useReducer } from 'react';
import {Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'
import image_1 from '../images/1.jpg'
import image_2 from '../images/2.jpg'
import image_3 from '../images/3.jpg'
import image_4 from '../images/4.jpg'
import image_5 from '../images/5.jpg'
import image_6 from '../images/6.jpg'
import image_7 from '../images/7.jpg'
import image_8 from '../images/8.jpg'
import image_9 from '../images/9.jpg'
import image_10 from '../images/10.jpg'
import image_11 from '../images/11.jpg'
import image_12 from '../images/12.jpg'

  class Coach extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
        categories: [
            'Build Muscle', 'Loose Weight', 'Strength And Conditioning', 'Sports Perfomance', 'KickBoxing', 'Pilates', 'Spin Class', 'Toning',
            'Rehabilitation', 'Older Adults and Geriatic Care', 'Yoga', 'Wellness Monitoring'
        ],
        build_muscle: 'none',
        loose_weight: 'none',
        strength_and_conditioning: 'none',
        sports_perfomance: 'none',
        kickboxing: 'none',
        pilates: 'none',
        spin_class: 'none',
        toning: 'none',
        rehabilitation: 'none',
        older_adults_and_geriatic_care: 'none',
        yoga: 'none',
        wellness_monitoring: 'none'
      };

      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };

      this.Highlight = (goal) => {
        if(this.state[goal] == 'none'){
            this.state[goal] = '5px solid #1FACED'
        }else{
            this.state[goal] = 'none'
        }
      }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }




    render() {

      return (
        <Row>
            <Helmet>
              <title>Goals - ONFIT</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
              <br/>
              <h3 style={{}}>
                Select Your Goal(s)
              </h3>
              <br/><br/><br/><br/>
              <Container>
                    <Button onClick={() => {this.props.UpdateGoals('Body Building'); this.Highlight('build_muscle')}} style={{backgroundImage: "url(" + image_1 + ")", height: '350px', width: '100%', border: this.state.build_muscle}}>
                        <div style={{height: '350px', backgroundColor: 'silver', opacity: 0.3, width: '104%', marginLeft: '-2%', marginTop: '-150px'}}>

                        </div>
                        <div style={{backgroundColor: '#1faced', borderRadius: '20px', width: '60%', marginTop: '-220px'}}>
                            <h4 style={{margin: '20px', color: '#ffffff'}}>
                                Body Building
                            </h4>
                        </div>
                    </Button>
                    <br/><br/><br/><br/>
                    <Button onClick={() => {this.props.UpdateGoals('Loose Weight'); this.Highlight('loose_weight')}} style={{backgroundImage: "url(" + image_2 + ")", height: '350px', width: '100%', border: this.state.loose_weight}}>
                        <div style={{height: '350px', backgroundColor: 'silver', opacity: 0.3, width: '104%', marginLeft: '-2%', marginTop: '-150px'}}>

                        </div>
                        <div style={{backgroundColor: '#1faced', borderRadius: '20px', width: '60%', marginTop: '-220px'}}>
                            <h4 style={{margin: '20px', color: '#ffffff'}}>
                                Loose Weight
                            </h4>
                        </div>
                    </Button>
                    <br/><br/><br/><br/>
                    <Button onClick={() => {this.props.UpdateGoals('Strength And Conditioning'); this.Highlight('strength_and_conditioning')}} style={{backgroundImage: "url(" + image_3 + ")", height: '350px', width: '100%', border: this.state.strength_and_conditioning}}>
                        <div style={{height: '350px', backgroundColor: 'silver', opacity: 0.3, width: '104%', marginLeft: '-2%', marginTop: '-150px'}}>

                        </div>
                        <div style={{backgroundColor: '#1faced', borderRadius: '20px', width: '60%', marginTop: '-220px'}}>
                            <h4 style={{margin: '20px', color: '#ffffff'}}>
                                Strength And Conditioning
                            </h4>
                        </div>
                    </Button>
                    <br/><br/><br/><br/>
                    <Button onClick={() => {this.props.UpdateGoals('Sports Perfomance'); this.Highlight('sports_perfomance')}} style={{backgroundImage: "url(" + image_4 + ")", height: '350px', width: '100%', border: this.state.sports_perfomance}}>
                        <div style={{height: '350px', backgroundColor: 'silver', opacity: 0.3, width: '104%', marginLeft: '-2%', marginTop: '-150px'}}>

                        </div>
                        <div style={{backgroundColor: '#1faced', borderRadius: '20px', width: '60%', marginTop: '-220px'}}>
                            <h4 style={{margin: '20px', color: '#ffffff'}}>
                                Sports Perfomance
                            </h4>
                        </div>
                    </Button>
                    <br/><br/><br/><br/>
                    <Button onClick={() => {this.props.UpdateGoals('KickBoxing'); this.Highlight('kickboxing')}} style={{backgroundImage: "url(" + image_5 + ")", height: '350px', width: '100%', border: this.state.kickboxing}}>
                        <div style={{height: '350px', backgroundColor: 'silver', opacity: 0.3, width: '104%', marginLeft: '-2%', marginTop: '-150px'}}>

                        </div>
                        <div style={{backgroundColor: '#1faced', borderRadius: '20px', width: '60%', marginTop: '-220px'}}>
                            <h4 style={{margin: '20px', color: '#ffffff'}}>
                                KickBoxing
                            </h4>
                        </div>
                    </Button>
                    <br/><br/><br/><br/>
                    <Button onClick={() => {this.props.UpdateGoals('Pilates'); this.Highlight('pilates')}} style={{backgroundImage: "url(" + image_6 + ")", height: '350px', width: '100%', border: this.state.pilates}}>
                        <div style={{height: '350px', backgroundColor: 'silver', opacity: 0.3, width: '104%', marginLeft: '-2%', marginTop: '-150px'}}>

                        </div>
                        <div style={{backgroundColor: '#1faced', borderRadius: '20px', width: '60%', marginTop: '-220px'}}>
                            <h4 style={{margin: '20px', color: '#ffffff'}}>
                                Pilates
                            </h4>
                        </div>
                    </Button>
                    <br/><br/><br/><br/>
                    <Button onClick={() => {this.props.UpdateGoals('Spin Class'); this.Highlight('spin_class')}} style={{backgroundImage: "url(" + image_7 + ")", height: '350px', width: '100%', border: this.state.spin_class}}>
                        <div style={{height: '350px', backgroundColor: 'silver', opacity: 0.3, width: '104%', marginLeft: '-2%', marginTop: '-150px'}}>

                        </div>
                        <div style={{backgroundColor: '#1faced', borderRadius: '20px', width: '60%', marginTop: '-220px'}}>
                            <h4 style={{margin: '20px', color: '#ffffff'}}>
                                Spin Class
                            </h4>
                        </div>
                    </Button>
                    <br/><br/><br/><br/>
                    <Button onClick={() => {this.props.UpdateGoals('Toning'); this.Highlight('toning')}} style={{backgroundImage: "url(" + image_8 + ")", height: '350px', width: '100%', border: this.state.toning}}>
                        <div style={{height: '350px', backgroundColor: 'silver', opacity: 0.3, width: '104%', marginLeft: '-2%', marginTop: '-150px'}}>

                        </div>
                        <div style={{backgroundColor: '#1faced', borderRadius: '20px', width: '60%', marginTop: '-220px'}}>
                            <h4 style={{margin: '20px', color: '#ffffff'}}>
                                Toning
                            </h4>
                        </div>
                    </Button>
                    <br/><br/><br/><br/>
                    <Button onClick={() => {this.props.UpdateGoals('Rehabilitation'); this.Highlight('rehabilitation')}} style={{backgroundImage: "url(" + image_9+ ")", height: '350px', width: '100%', border: this.state.rehabilitation}}>
                        <div style={{height: '350px', backgroundColor: 'silver', opacity: 0.3, width: '104%', marginLeft: '-2%', marginTop: '-150px'}}>

                        </div>
                        <div style={{backgroundColor: '#1faced', borderRadius: '20px', width: '60%', marginTop: '-220px'}}>
                            <h4 style={{margin: '20px', color: '#ffffff'}}>
                                Rehabilitation
                            </h4>
                        </div>
                    </Button>
                    <br/><br/><br/><br/>
                    <Button onClick={() => {this.props.UpdateGoals('Older Adults and Geriatic Care'); this.Highlight('older_adults_and_geriatic_care')}} style={{backgroundImage: "url(" + image_10 + ")", height: '350px', width: '100%', border: this.state.older_adults_and_geriatic_care}}>
                        <div style={{height: '350px', backgroundColor: 'silver', opacity: 0.3, width: '104%', marginLeft: '-2%', marginTop: '-150px'}}>

                        </div>
                        <div style={{backgroundColor: '#1faced', borderRadius: '20px', width: '60%', marginTop: '-220px'}}>
                            <h4 style={{margin: '20px', color: '#ffffff'}}>
                                Older Adults and Geriatic Care
                            </h4>
                        </div>
                    </Button>
                    <br/><br/><br/><br/>
                    <Button onClick={() => {this.props.UpdateGoals('Yoga'); this.Highlight('yoga')}} style={{backgroundImage: "url(" + image_11 + ")", height: '350px', width: '100%', border: this.state.yoga}}>
                        <div style={{height: '350px', backgroundColor: 'silver', opacity: 0.3, width: '104%', marginLeft: '-2%', marginTop: '-150px'}}>

                        </div>
                        <div style={{backgroundColor: '#1faced', borderRadius: '20px', width: '60%', marginTop: '-220px'}}>
                            <h4 style={{margin: '20px', color: '#ffffff'}}>
                                Yoga
                            </h4>
                        </div>
                    </Button>
                    <br/><br/><br/><br/>
                    <Button onClick={() => {this.props.UpdateGoals('Wellness Monitoring'); this.Highlight('wellness_monitoring')}} style={{backgroundImage: "url(" + image_12 + ")", height: '350px', width: '100%', border: this.state.wellness_monitoring}}>
                        <div style={{height: '350px', backgroundColor: 'silver', opacity: 0.3, width: '104%', marginLeft: '-2%', marginTop: '-150px'}}>

                        </div>
                        <div style={{backgroundColor: '#1faced', borderRadius: '20px', width: '60%', marginTop: '-220px'}}>
                            <h4 style={{margin: '20px', color: '#ffffff'}}>
                            Wellness Monitoring
                            </h4>
                        </div>
                    </Button>
                    <br/><br/><br/><br/>
                    <div  style={{textAlign: 'right'}}>
                        <Button onClick={() => this.props.ChangeCurrentRender('training_method')} style={{backgroundColor: '#1faced', color: '#FFFFFF', border: 'none', borderRadius: '20px', width: '30%'}}>
                            Next <span style={{fontWeight: 'bold'}}>{'>>>'}</span>
                        </Button>
                    </div>
                    <br/><br/><br/><br/>
              </Container>
            </div>
        </Row>
      );
    }

  };
  
  export default withCookies(Coach);